<template>
  <div id="monthlyReports" class="margin-subpages">
    <div class="fs-18 fw-700">{{ $t("reports.MONTHLY_REPORT_PREVIEW") }}</div>
    <div class="line-section"></div>
    <div class="flex-center">
      <div class="mr-16">
        <el-cascader
          v-model="managerSelected"
          :placeholder="$t('reports.Select_a_Person')"
          :options="peopleList"
          :filter-method="filterManagerFunction"
          filterable
          clearable
        >
        <template slot-scope="{ node, data }">
          <span class="fs-14">{{ data.firstname }} {{ data.lastname }}</span>
        </template>
        </el-cascader>
      </div>
      <div>
        <el-date-picker
          v-model="dateSelected"
          type="month"
          format="MMMM, yyyy"
          value-format="yyyy-MM"
          :placeholder="$t('reports.Select_month')"
          :picker-options="pickerOptions"
          placement="bottom-start"
        >
        </el-date-picker>
      </div>
      <!-- <div class="pl-20" v-if="this.inforMonthlyData && this.inforMonthlyData.file">
        <img
          @click=" downloadInnerHtml(fileName, 'test_download','text/html')"
          :src="$utils('icons', 'ic_xls_download')"
          class="mt-3 icon-export"
        />
      </div> -->
    </div>
    <div class="mock-email" v-if="managerSelected && dateSelected && inforMonthlyData.preview">
      <div class="body-email center" id="test_download">
        <!-- <link rel="inforMonthlyData.preview" href="styles.css" /> -->
        <iframe
          ref="iframeRef"
          id="iframeRef"
          :src="inforMonthlyData.preview"
          width="900"
          class="thin-scrollbar iframe-container"
        ></iframe>
      </div>
    </div>
    <div v-if="blurMode"
      :class="['demomode-warning', 'flex-between']">
      <div>{{ $t("demomode.warning") }}</div>
    </div>
    <!-- <div v-if="managerSelected && dateSelected && !loadingMonthlyReportStatus && Object.keys(user).length > 0 && loadingProgress>99" class="m-auto p-16" style="width: 800px">
      <div v-if="userDetected" class="pt-2">
        <monthly :user="user" />
        <strengths v-if="managerUser[user.id]" :user="user" />
        <engaged :user="user" />
        <connections :user="user" />
        <growing :user="user" />
      </div>
    </div> -->
    <div
      v-else
      class="center fc-A0A0A0 fs-24 preview-reports mt-32"
    >
      <div v-if="!managerSelected || !dateSelected" style="padding-top: 80px">
        <div class="fs-16 fw-700 fc-000000 opa-04">
          {{ $t("reports.Preview_a_report_by") }} <br /> {{ $t("reports.from_the_above_menu") }}
        </div>
      </div>
      <div v-else-if="loadingMonthlyReportStatus" style="padding-top: 80px">
        <i class="el-icon-loading"></i>
        <div class="fs-16">{{ $t("reports.Loading") }}...</div>
      </div>
      <div v-else-if="!loadingMonthlyReportStatus && !inforMonthlyData.preview" style="padding-top: 80px">
        <div class="fs-16">{{ $t("reports.Unable_to_preview_this") }}</div>
      </div>
    </div>
    <!-- <div v-else>
      <div
        class="flex-mid center fc-A0A0A0"
        style="height: 700px; font-size: 80px"
      >
        <div style="margin-bottom: 240px;">
          <i class="el-icon-folder-opened"></i>
          <div class="fs-24">
            Select
            <span v-if="managerSelected || dateSelected"> a </span>
            <span v-if="!managerSelected">Manager</span>
            <span v-if="!managerSelected && !dateSelected"> and </span>
            <span v-if="!dateSelected">Date</span>
          </div>
        </div>
      </div>
    </div> -->
    <download-progress :active="showSnackbar"></download-progress>
  </div>
</template>

<script>
import addMonths from "date-fns/add_months";
import html2pdf from 'html2pdf.js'
import axios from 'axios'
export default {
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  computed: {
    user() {
      return this.$store.getters["monthlyInsignhts/user"];
    },
    userLogin() {
      return this.$store.getters["authen/user"];
    },
    managerUser() {
      return this.$store.getters["monthlyInsignhts/managerUser"];
    },
    peopleList() {
      return this.$store.getters["reportPreview/peopleList"];
    },
    inforMonthlyData() {
      return this.$store.getters["reportPreview/inforMonthlyData"];
    },
    loadingMonthlyReportStatus() {
      return this.$store.getters["reportPreview/loadingMonthlyReportStatus"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  watch: {
    dateSelected() {
      this.getDataToPreview();
    },
    managerSelected() {
      this.getDataToPreview();
    },
    user() {
      setTimeout(() => {
        this.$store.dispatch("monthlyEngaged/getTeam",this.user);
        this.$store.dispatch("monthlyStrength/getQuaterHeader",this.user);
        this.$store.dispatch("monthlyStrength/getDataStrength",this.user);
        let item = {
          ...this.user,
          boss: this.user.bossName,
        };
        this.$store.dispatch("newmember/getModalMemberData", item);
      }, 5000)
    }
  },
  data() {
    return {
      firstTimeloading: true,
      managerSelected: "",
      showSnackbar: false,
      // peopleList: [
      //   {
      //     value: "id13564asd613264",
      //     label: "Adison Riewthong",
      //   },
      //   {
      //     value: "id13564asd613264",
      //     label: "Chanitra Suthamma",
      //   },
      //   {
      //     value: "id112564614s3264",
      //     label: "Ittigorn Tradussadee",
      //   },
      //   {
      //     value: "id13561261f3264",
      //     label: "Kantamad Luemon",
      //   },
      // ],
      dateSelected: "",
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      // dateList: [
      //   {
      //     value: "Monday, July",
      //     label: "Monday, July",
      //   },
      //   {
      //     value: "Monday, June",
      //     label: "Monday, June",
      //   },
      //   {
      //     value: "Monday, May",
      //     label: "Monday, May",
      //   },
      //   {
      //     value: "Monday, April",
      //     label: "Monday, April",
      //   },
      // ],
    };
  },
  created() {
    this.$store.dispatch("reportPreview/getOrganization1level", this.user).then(()=>{
      this.$store.dispatch("reportPreview/getPeopleOption",this.userLogin);
      this.$store.dispatch("monthlyInsignhts/getUserManager",this.userLogin);
    });
    
    // const month = this.$router.currentRoute.query.month || "06"; // get now
    // const year = this.$router.currentRoute.query.year || "2021"; // get now
    // const value = { email: "user@example.com", month: month, year: year };
    // this.$store.dispatch("monthlyInsignhts/getUser", value);
  },
  methods: {
    disabledDate(date) {
      return addMonths(new Date(), -1) < date || date < new Date("2021-05-31");
    },
    getDataToPreview() {
      if(this.managerSelected[0] && this.dateSelected){
        this.firstTimeloading = false;
        this.$store.dispatch("reportPreview/getDataPreviewMonthly", {
          user: this.managerSelected[0],
          date: this.dateSelected,
          type: "report_monthly",
          loading: "Monthly",
        });
      }
    },
    downloadInnerHtml(filename, elId, mimeType) {
      // var elHtml = document.getElementById(elId).innerHTML;
      // var link = document.createElement('a');
      // mimeType = mimeType || 'text/plain';

      // link.setAttribute('download', filename);
      // link.setAttribute('href', 'data:' + mimeType  +  ';charset=utf-8,' + encodeURIComponent(elHtml));
      // link.click();
      (async () => {
        const response = await fetch(this.inforMonthlyData.preview);
        const template = await response.text();
        //console.log(template);
      })();
    },
    filterManagerFunction(node, keyword) {
      let keywordArr = keyword.split(" ");
      if (keywordArr.length > 1) {
        for (let i = 0;i < keywordArr.length; i++) {
            if (
              node.data.firstname.toLowerCase().indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (
              node.data.lastname.toLowerCase().indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            }
        }
      } else {
          return (
            node
              .getText(false, null)
              .toLowerCase()
              .indexOf(keyword.toLowerCase()) >= 0
          );
      }
    },
    // async exportReport() {
    //   let file = ''
    //   file = this.inforMonthlyData.file
    //   if(file && !this.showSnackbar){
    //     this.showSnackbar = true
    //     axios({
    //       method: "get",
    //       url: file
    //     })
    //       .then(result => {
    //         let body = document.body
    //         let html = document.documentElement
    //         let height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
    //         let heightCM = height / 35.35
    //         let resultData = result.data
    //         const regex = /[(http(s)?):\/\/(www\.)?-a-zA-Z0-9@:%.\+#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%\+.#?&//=]*)/ig
    //         const found = resultData.match(regex)
    //         for(const x in found){
    //           const sp = found[x].split('connected-pub.s3.ap-southeast-1.amazonaws.com/happily/')
    //           if(sp.length > 1){
    //             let name = sp[1]
    //             name = name.replace(/\//g, '%2F')
    //             let text = `https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Freport_images%2F${name}?alt=media`
    //             resultData = resultData.replace(found[x],text)
    //           }
    //           const sp2 = found[x].split('s3-ap-southeast-1.amazonaws.com/connected-pub/happily/')
    //           if(sp2.length > 1){
    //             let name2 = sp2[1]
    //             name2 = name2.replace(/\//g, '%2F')
    //             let text2 = `https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Freport_images%2F${name2}?alt=media`
    //             resultData = resultData.replace(found[x],text2)
    //           }
    //           const sp3 = found[x].split('connected-pub.s3-ap-southeast-1.amazonaws.com/happily/')
    //           if(sp3.length > 1){
    //             let name3 = sp3[1]
    //             name3 = name3.replace(/\//g, '%2F')
    //             let text3 = `https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Freport_images%2F${name3}?alt=media`
    //             resultData = resultData.replace(found[x],text3)
    //           }
    //         }
    //         html2pdf(resultData, {
    //           margin: 1,
    //           filename: `${this.inforMonthlyData.file_name}.pdf`,
    //           html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
    //           jsPDF: {
    //             orientation: 'portrait',
    //             unit: 'cm',
    //             format: [heightCM, 27.093333333]
    //           }
    //         })
    //         setTimeout(() => {
    //           this.showSnackbar = false
    //         }, 5000);
    //       })
    //       .catch(error => {
    //         console.error("error getting file");
    //       });
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.preview-reports {
  height: 1000px;
}
.line-section {
  margin: 20px 0;
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
}
#monthlyReports {
  .mock-email {
    background-color: #f4f4f4;
    border-radius: 6px;
    margin-top: 32px;

    .body-email {
      background: #fff;
      margin: auto;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
}
.demomode-warning {
  border: #f5184c solid 2px;
  border-radius: 3px;
  background-color: #f72d3d;
  color: #ffffff;
  font-size: 13px;
  font-family: "Roboto", 'Kanit', sans-serif;
  font-weight: 500;
  padding: 9px 15px;
  margin: 27px 0px 13px;
  opacity: 0.8;
}
</style>